<template>
    <div
        v-if="volwasssenenTarief > 0"
        class="verzorgingtitle regel borderbottom lineheight32 floatleft paddingtop5 paddingbottom5"
    >
        <div
            v-if="content != ''"
            v-on:mouseenter="mouseEnter"
            v-on:mouseleave="mouseLeave"
            class="label width20 floatleft bold uppercase"
        >
            <span class="floatleft paddingleft10">Verzorging: </span>
            <span class="floatleft marginleft10">
                <font-awesome-icon class="cruiseinfoimg" icon="info-circle" />
            </span>
        </div>

        <transition name="fade" appear>
            <div
                v-show="showPopup"
                v-html="content"
                style="position: absolute; z-index: 999999; left: 150px;"
                class="div_extra_informatie"
            ></div>
        </transition>

        <div class="width70 marginleft5 verzorging">
            <input
                v-model="verzorgingType"
                type="radio"
                class="marginright5"
                name="verzorging"
                value="volpension"
                id="verzorging_volpension"
            />
            <label for="verzorging_volpension"> Volpension </label>
            <input
                v-model="verzorgingType"
                type="radio"
                class="marginright5 marginleft15"
                name="verzorging"
                value="all-inclusive"
                id="verzorging_all_inclusief"
            />
            <label for="verzorging_all_inclusief"> All-inclusive</label>
            <div
                class="width100 marginleft5 verzorging"
                v-if="verzorgingType === 'all-inclusive'"
            >
                <div class="width40 floatleft">Kies je drankenpakket:</div>
                <div class="select-drop floatleft marginleft15">
                    <select
                        v-model="selectedPakket"
                        @change="selectPakket(selectedPakket)"
                        class="selectpaddingsmall"
                    >
                        <option
                            v-for="(pakket, index) in drankenpakket"
                            :key="'pakket' + index"
                            :value="pakket"
                        >
                            {{ pakket.pakket_naam }}
                            <span v-html="pakket.curtype"></span
                            >{{ pakket.pakket_prijs }} p.p.
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Verzorging',
    data: function() {
        return {
            contentFallback:
                'Ontbijt, lunch en diner zijn altijd bij de cruise inbegrepen. Voor (alcoholische) dranken dient u apart te betalen, maar door een drankenpakket af te nemen, is alles inclusief.',
            showPopup: false,
            selectedPakket: this.$store.state.selectedPakket,
        }
    },
    methods: {
        mouseLeave: function() {
            this.showPopup = false
        },
        mouseEnter: function() {
            this.showPopup = true
        },

        numberWithCommas: function(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },

        roundPrice: function(price) {
            if (!price) return '-'
            if (isNaN(price)) return '?'
            let parsed = price.toFixed(2)
            return this.numberWithCommas(
                parsed
                    .split('.')
                    .join(',')
                    .replace(',00', ',-')
            )
        },
        selectPakket: function(pakket) {
            this.$store.state.selectedPakket = pakket
        },
    },
    computed: {
        cruise: function() {
            return this.$store.state.cruise
        },
        drankenpakket: function() {
            let drankenpakketten = []
            this.$store.state.drankenpakketten.map(function(pakket) {
                if (pakket.optie_kinder === 0) {
                    pakket.curtype = ' &#36;'
                    if (pakket.currency === 1) {
                        pakket.curtype = ' &euro;'
                    }
                    drankenpakketten.push(pakket)
                }
            })

            return drankenpakketten
        },
        content: function() {
            if (this.cruise.content_drankenpakketten !== '') {
                return this.cruise.content_drankenpakketten
            }
            return this.contentFallback
        },
        volwasssenenTarief: function() {
            return this.cruise.tarief_drankenpakket_volwassenen
        },
        kinderenTarief: function() {
            return this.cruise.tarief_drankenpakket_kinderen
        },
        show: function() {
            return this.cruise.tarief_drankenpakket_volwassenen > 0
        },
        verzorgingType: {
            get: function() {
                return this.$store.state.verzorgingType
            },
            set: function(value) {
                this.$store.state.verzorgingType = value
            },
        },
    },
}
</script>

<style scoped></style>
